import { EnumGender } from "../Enum/EnumGender";

class EligibilityPatientDemographicInformation {
    public DateOfBirth?: Date;
    public FirstName?: string;
    public Gender?: EnumGender;
    public LastName?: string;
    public MiddleName?: string;

    public constructor(fields?: Partial<EligibilityPatientDemographicInformation>) {
        Object.assign(this, fields);
    }
}

export { EligibilityPatientDemographicInformation };
